import * as React from 'react';
import { newConfirmModal } from 'Views/Components/Modal/NewConfirmModal';
import { convertGuestViaStaff } from 'Services/Api/_HumanWritten/RegisterService';
import alertToast from 'Util/ToastifyUtils';

/**
 * Shared staff flow to convert a guest into a full account. Shows the same confirmation everywhere
 * it's triggered (account details tab, user table row action), converts the guest, then runs
 * `onSuccess` (e.g. refetch the user / refresh the list). The guest is promoted as-is — the backend
 * keeps their existing details and emails them an activate-account link to set their own password.
 */
export function confirmAndConvertGuest(email: string, onSuccess: () => void) {
	newConfirmModal(
		'Convert guest to full account',
		<div className="spaced-message">
			<p>
				This will convert <strong className="brand-colour">{email}</strong> into a full account.
			</p>
			<p>
				A verification email will be sent so they can set their own password. Are you sure you want to proceed?
			</p>
		</div>,
		{
			confirmText: 'Convert',
			cancelText: 'Cancel',
		},
	)
		.then(async confirmed => {
			if (!confirmed) {
				return;
			}
			try {
				await convertGuestViaStaff({ email });
				alertToast('A verification email has been sent so they can set a password.', 'success', 'Converted');
				onSuccess();
			} catch {
				alertToast('Could not convert guest to a full account.', 'error', 'Error');
			}
		})
		.catch(() => {
			// Modal dismissed - do nothing
		});
}
